import axios from 'axios'
// import store from '@/store/'

const env = process.env.NODE_ENV === 'production'

const config = () => {
  // const port = store.getters.theApis.fdc.sitePort
  // return {
  //   // url: env ? 'http://' + store.getters.theApis.fdc.siteIp : 'http://localhost',
  //   url: env ? ((process.env.VUE_APP_HTTPS_ENABLE === 'true' ? 'https://' : 'http://') + store.getters.theApis.fdc.siteIp) : 'http://10.250.172.47',
  //   port: env ? port : '15012'
  // }
  return {
    // url: env ? 'http://' + store.getters.theApis.fdc.siteIp : 'http://localhost',
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004')
  }
}

export default {
  deleteFabByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/fab/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  deleteEqpByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/eqp/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  deleteRecipeByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/recipe/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  deleteStepByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/step/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  deleteParamByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/parameter/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  deleteEventByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/event/delete', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  saveFabByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/fab/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  saveEqpByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/eqp/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  saveRecipeByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/recipe/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  saveStepByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/step/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  saveParamByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/parameter/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  saveEventByAdmin: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/mts/useinfo/event/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  },
  fabList: async () => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/mts/useinfo/fab/list')
      return response.data === null ? [] : response.data
    } catch (error) {
      console.error(error)
    }
  },
  eqpList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/mts/useinfo/eqp/list', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  recipeList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/mts/useinfo/recipe/list', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  stepList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/mts/useinfo/step/list', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  parameterList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/mts/useinfo/parameter/list', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  eventList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/mts/useinfo/event/list', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  }
}
